import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@readsavor/api-client';
import { useAuthStore, userQueryKeys } from '@readsavor/auth';
export const creditKeys = {
    all: ['credits'],
    balance: () => [...userQueryKeys.all, ...creditKeys.all, 'balance'],
};
/**
 * Fetches the credit balance for the current authenticated user.
 *
 * This hook encapsulates the logic for calling the `apiClient.credits.getBalance`
 * endpoint and manages the query state using React Query.
 *
 * It is only enabled when there is an active user session.
 */
export const useCreditBalance = () => {
    const status = useAuthStore(state => state.status);
    const isInitializationComplete = useAuthStore(state => state.isInitializationComplete);
    const enabled = status === 'authenticated' && isInitializationComplete;
    return useQuery({
        queryKey: creditKeys.balance(),
        queryFn: () => {
            return apiClient.credits.getBalance();
        },
        enabled: enabled,
        staleTime: 5 * 60 * 1000, // 5 minutes
        // Add retry logic to handle the race condition on initial load
        retry: 3,
        retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 10000), // Exponential backoff
    });
};
//# sourceMappingURL=useCreditBalance.js.map